import styled from '@emotion/styled'

const LegendContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 0.5rem;
    font-size: 12px;
    color: #666;
`

const LegendColorBox = styled.div`
    width: 21px;
    height: 21px;
    border: 1px solid #d1d5db;
    font-size: 10px;
    font-weight: 600;
`

const LegendItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const LegendItemText = styled.div`
    font-size: 10px;
    font-weight: 600;
`

export { LegendContainer, LegendColorBox, LegendItem, LegendItemText }
